import React, {PureComponent} from 'react';
import ReactQuill from 'react-quill';
import {modules, formats} from 'constants/baseConst';
import TextField from 'material-ui/TextField';
import { inject, observer } from 'mobx-react';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import {TOPIC_TYPE, TOPIC_TYPES} from 'constants/topicTypes';

@inject('topicsStore')
@observer
class InputWithEditor extends PureComponent {
  handleChangeTitle = e => {
    this.props.topicsStore.handleChange({ [e.target.name]: e.target.value });
  }

  handleDescription = description => {
    this.props.topicsStore.handleChange({description});
  }

  handleChangeICGP = e => {
    this.props.topicsStore.handleChange({ [e.target.name]: e.target.value });
  }

  handleChangeCPDPoints = e => {
    this.props.topicsStore.handleChange({ [e.target.name]: e.target.value });
  }

  handleChangeType = e => {
    this.props.topicsStore.handleChange({ [e.target.name]: e.target.value });
  };

  render() {
    const {topicsStore} = this.props;
    const errors = topicsStore.errors || {};
    const tutorialType = TOPIC_TYPES[topicsStore.topic.tutorial_type] || TOPIC_TYPES[topicsStore.topic.tutorial_type] === 0 ? TOPIC_TYPES[topicsStore.topic.tutorial_type] : topicsStore.topic.tutorial_type;

    return (
      <div className="tab-container">
        <div className="row justify-content-center">
          <h3 className='container-header'>Prescription Revision Topic</h3>
        </div>
        <div className="row">
          <div className="col-12 container-body">
            <ReactQuill
              name={ 'name' }
              placeholder={ 'Start writing text here. Add text, photo and link.' }
              value={ topicsStore.topic.description || '' }
              onChange={ this.handleDescription }
              modules={ modules }
              formats={ formats }
              className={ `quill-toolbar-position` }
            >
              <div style={{ width: '100%', position: 'absolute', top: `${100}%`, height: 'auto', border: 0 }}></div>
            </ReactQuill>
            <TextField
              hintText='Add a Title'
              fullWidth={true}
              onChange={this.handleChangeTitle}
              value={topicsStore.topic.title}
              name='title'
              errorText={errors.title}
            />
            <TextField
              hintText='ICGP'
              fullWidth={true}
              onChange={this.handleChangeICGP}
              value={topicsStore.topic.icgp_number}
              name='icgp_number'
              errorText={errors.icgp_number}
            />
            <TextField
              hintText='CPD points'
              fullWidth={true}
              onChange={this.handleChangeCPDPoints}
              value={topicsStore.topic.cpd_points}
              name='cpd_points'
              errorText={errors.cpd_points}
            />
            <SelectFieldWrapper
              elements={TOPIC_TYPE}
              placeholder="Topic type:"
              name='tutorial_type'
              value={tutorialType}
              onChange={this.handleChangeType}
              errorText={errors.tutorial_type}
              fullWidth={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default InputWithEditor;


// WEBPACK FOOTER //
// ./src/modules/topic/components/InputWithEditor.js